var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectives({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8288 6.84002L8.14361 4.52521",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14362 4.52518L8.45915 2.44202L10.2634 0.668823L10.5423 2.12649L12 2.40535L10.2268 4.20965L8.14362 4.52518V4.52518Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4056 5.53675C12.0099 7.82738 11.0554 10.2449 9.04925 11.5049C7.04312 12.7649 4.45092 12.5749 2.64992 11.0359C0.848916 9.49694 0.257061 6.96608 1.18881 4.78802C2.12057 2.60996 4.3597 1.29016 6.71653 1.52985",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99856 6.21672C9.29813 7.4246 8.79839 8.68951 7.75417 9.3665C6.70994 10.0435 5.35122 9.98343 4.37078 9.21697C3.39035 8.4505 3.00416 7.14643 3.40911 5.96969C3.81407 4.79294 4.92098 4.0027 6.16546 4.00189",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32902 11.5013L2.91238 13.1679",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1619 11.5013L9.57853 13.1679",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectives);
export default __webpack_public_path__ + "static/media/objectives.9dcc9924c80f052cc7f97245c2486394.svg";
export { ForwardRef as ReactComponent };